<script lang="ts">
	import type { AddressData } from "@hitit/api";
	import { t, api } from "../../stores";
	import {
		DefaultButton,
		SearchIcon,
		DefaultTextInput,
		FormSlotComposite,
	} from "@hitit/new_ui/src";

	export let clickCallback: (addressDTO: AddressData) => void = () => {};

	let searchAddress = "";
	let searchLoading = false;
	let searchResult: AddressData[] = [];
	let searchErrorMessage = "";

	async function addressSearch() {
		try {
			if (!searchAddress) {
				return;
			}
			searchLoading = true;
			const r = await $api.searchAddress(0, 0, searchAddress);
			const result = r.data.results;

			if (result.length === 0) {
				searchResult = [];
				throw new Error($t("hub.create_store.error.no_search_result"));
			}

			searchResult = result;
			searchErrorMessage = "";
		} catch (e) {
			const _e = e as Error;
			searchErrorMessage = _e.message;
		} finally {
			searchLoading = false;
		}
	}

</script>

<div class="address" id="search-address">
	<form on:submit|preventDefault={addressSearch}>
		<FormSlotComposite
			outerClassname={'createstore-composite'}
			inputName={$t('hub.store.storeinfo.search_address')}>
			<div class="input-frame">
				<DefaultTextInput
					defaultClassName={'text-input'}
					clearButtonDisplay={searchAddress !== ''}
					clearCallback={() => (searchAddress = '')}
					bind:value={searchAddress}
					placeholder={$t('hub.store.storeinfo.placeholder.search_address')} />
				<div class="search-add-box">
					<DefaultButton
						defaultClassname={'button'}
						isLoading={searchLoading}
						disabled={searchLoading}
						on:click={addressSearch}>
						<SearchIcon />
					</DefaultButton>
				</div>
			</div>
		</FormSlotComposite>
	</form>
	<div class="address-search-result">
		{#each searchResult as add}
			<div class="result" on:click={() => clickCallback(add)}>
				<div class="row">
					<div class="label">{$t('hub.store.storeinfo.road')}</div>
					<div class="add">{add.formattedAddress1}</div>
				</div>
				<div class="row">
					<div class="label">
						{@html $t('hub.store.storeinfo.numb')}
					</div>
					<div class="add">{add.formattedAddress2}</div>
				</div>
			</div>
		{:else}
			{#if searchErrorMessage !== ''}
				<p class="error">{searchErrorMessage}</p>
			{:else}
				<ul>
					<li>{$t('hub.store.storeinfo.placeholder.add_1')}</li>
					<li>{$t('hub.store.storeinfo.placeholder.add_2')}</li>
					<li>{$t('hub.store.storeinfo.placeholder.add_3')}</li>
					<li>{$t('hub.store.storeinfo.placeholder.add_4')}</li>
				</ul>
			{/if}
		{/each}
	</div>
</div>

<style lang="scss">
	@import "../../variables.scss";

	:global(#search-address .input-frame .search-add-box .button) {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	/* Mobile First */
	.address {
		.input-frame {
			display: flex;
			gap: 10px;
		}

		.search-add-box {
			min-width: 60px;
		}
		.address-search-result {
			overflow: auto;
			height: 458px;
			margin-top: 20px;
			ul {
				li {
					margin-bottom: 10px;
					color: var(--lightGrey);
				}
			}

			.error {
				color: var(--error-color-1);
			}

			.result {
				display: flex;
				flex-direction: column;
				gap: 10px;
				padding: 20px 10px 20px 10px;
				transition: 0.15s color;
				&:hover {
					cursor: pointer;
				}

				&:not(:last-child) {
					border-bottom: 1px solid #62646a;
				}

				.row {
					display: flex;
					gap: 10px;
					.label {
						color: var(--dirty-white-1);
					}
					.add {
						color: white;
						font-size: 1.125rem;
					}
				}
			}
			&::-webkit-scrollbar {
				width: 2px;
			}
			&::-webkit-scrollbar-track {
				background-color: transparent;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #bcbfc3;
			}
		}
	}

	@include DesktopSize {
		.address {
			margin-top: 19px;

			.input-frame {
				gap: 20px;
			}

			.search-add-box {
				min-width: 80px;
			}

			.address-search-result {
				height: 412px;
			}
		}
	}

</style>
